module.exports = __webpack_public_path__ + "static/media/css.c64430b2.svg";